import EmptyWorkspace from './EmptyWorkspace';

export default EmptyWorkspace;
